import { PortfolioPageView } from './PortfolioPageView';
import { usePortfolioPage } from './hooks/usePortfolioPage';

export function PortfolioPageContainer() {
  const viewProps = usePortfolioPage();
  return <PortfolioPageView {...viewProps} />;
}
